<template>
  <report-container
    v-if="currentPageName === 'adx-and-open-bidding'"
    :actions="actions"
  >
    <template v-slot:report-modals />
  </report-container>
</template>

<script>
import mixin from '../components/mixin'

export default {
  name: 'AdxAndOpenBidding',
  components: {
    ReportContainer: () => import('src/report/components/ReportContainer'),
  },
  mixins: [mixin],
  data() {
    return {
      actions: [
        {
          event: 'programmatic/openAdServerLink',
          name: 'GAM Deep Link',
        },
      ],
    }
  },
}
</script>
